import React from 'react'
import { TextField, InputAdornment } from '@material-ui/core'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import { useController } from 'react-hook-form'

export default function RoundupCap({ control, ...passThroughProps }) {
  const defaultValue = useCurrentUserProp('monthlyRoundupCap') || ''

  const { field, fieldState: { error, invalid } } = useController({name: 'monthlyRoundupCap', defaultValue, control})

  return (
    <TextField
      {...field}
      label='Monthly Roundup Cap'
      type='number'
      InputProps={{ startAdornment: <InputAdornment position='start'>$</InputAdornment> }}
      helperText={error?.message || 'Optional'}
      error={invalid}
      { ...passThroughProps }
    />
  )
}